var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleDeclined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.400053,34.6L34.6,15.399893M34.6,34.6L15.400053,15.399893M49,25c0,13.254933-10.745067,24-24,24C11.745173,49,1,38.254933,1,25C1,11.745173,11.745173,1,25,1C38.254933,1,49,11.745173,49,25Z",
    stroke: "#ff5151",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDeclined);
export default __webpack_public_path__ + "static/media/circle-declined.5bd695857dce0fde237e1f52a03e52e4.svg";
export { ForwardRef as ReactComponent };